import FlexRow from "@/components/FlexRow.vue";
import { TextValue } from "@/components/tableElements";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
import { WrapWithSectionItem } from "../sections";
export default {
  name: "CustomFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    item_name: String,
    item_id: String,
    item_name_key: String,
    item_id_key: String,
    selected: Boolean,
    // Search term to highlight within the label.
    query: {
      type: String,
      default: ""
    }
  },
  components: {
    WrapWithSectionItem,
    TextValue,
    HighlightTextValue,
    FlexRow
  }
};